export default __webpack_public_path__ + "static/media/sportsfullgroup.62cbbd8a.jpg";